import React from 'react';

const LocationIcon = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <path
      d="M14.6631 2C12.9158 2.00071 11.2013 2.475 9.70204 3.37242C8.20279 4.26984 6.9748 5.55684 6.14868 7.09654C5.32256 8.63624 4.92921 10.3711 5.01046 12.1165C5.0917 13.8619 5.64451 15.5527 6.61008 17.009C8.67208 20.43 14.6631 27 14.6631 27C14.6631 27 20.6631 20.43 22.7201 17.009C23.6858 15.5524 24.2387 13.8613 24.3198 12.1155C24.4008 10.3697 24.0071 8.6346 23.1805 7.09478C22.3539 5.55495 21.1254 4.26801 19.6256 3.37088C18.1257 2.47375 16.4107 1.99999 14.6631 2V2Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2203 11.6031C19.2012 12.4995 18.9179 13.3703 18.406 14.1063C17.8941 14.8424 17.1763 15.411 16.3426 15.7408C15.5089 16.0706 14.5964 16.147 13.7195 15.9604C12.8425 15.7738 12.0402 15.3325 11.413 14.6918C10.7858 14.0512 10.3617 13.2396 10.1938 12.3589C10.026 11.4782 10.1218 10.5675 10.4693 9.74105C10.8168 8.91457 11.4005 8.20905 12.1473 7.71293C12.8941 7.2168 13.7707 6.95215 14.6673 6.95215C15.2717 6.95829 15.869 7.08349 16.425 7.3206C16.981 7.55772 17.4848 7.90209 17.9077 8.33403C18.3305 8.76598 18.6641 9.27703 18.8893 9.83796C19.1145 10.3989 19.227 10.9987 19.2203 11.6031V11.6031Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LocationIcon;
